import React from 'react'

interface ValidationErrorProps {
  show: boolean
  message: string
}

const ValidationError: React.FC<ValidationErrorProps> = ({ show, message }) => {
  if (!show || !message) return null

  return <div className="card-error">{message}</div>
}

export default ValidationError
